import useSWR, { mutate } from 'swr'
import NProgress from 'nprogress'
import api from './api'
import { Toast } from '../components/chakra/Toast'
import { updateFolderWithId } from './folder'

const updateTags = (bookmark, setTags) => {
  if (bookmark?.tags?.length) {
    setTags(tags => {
      const newTags = [...tags, ...bookmark?.tags]
      const newTagsObject = newTags.reduce((acc, current) => {
        acc[current._id] = current
        return acc
      }, {})
      return Object.values(newTagsObject)
    })
  }
}

export const getAutoTags = async (title, description, url, tags) => {
  const res = await api.post(`/bookmarks/autoTags`, { bookmark: { title, description, url, tags } })
  return res.data.tags
}

export const createBookmark = async (payload, setBookmarks, setTags, errorFc, isOwner) => {
  let response
  try {
    response = await api.post('/bookmarks', { ...payload })
  } catch (e) {
    Toast.close('creating-editing-bookmark')
    errorFc(e)
    NProgress.done()
    return {}
  }
  // const response = await api.post('/bookmarks', { ...payload })
  if (isOwner) {
    setBookmarks(bookmarks => [response?.data || [], ...(bookmarks || [])])
  } else {
    setBookmarks(bookmarks => [...(bookmarks || [])])
  }
  updateTags(response?.data, setTags)
  Toast.close('creating-editing-bookmark')
  return response?.data
}

export const editBookmark = async (payload, setBookmarks, setTags, errorFc, isOwner, setRecoilBookmarks) => {
  let response
  try {
    response = await api.put(`/bookmarks/${payload.paramId}`, { ...payload })
  } catch (e) {
    Toast.close('creating-editing-bookmark')
    errorFc(e)
    NProgress.done()
    return {}
  }
  // const response = await api.put(`/bookmarks/${payload.paramId}`, { ...payload })
  if (isOwner) {
    setBookmarks(bookmarks => {
      const newBookmarks = [...bookmarks]
      const index = newBookmarks.findIndex(({ _id }) => _id === response?.data?._id)
      if (index !== -1) {
        // eslint-disable-next-line no-param-reassign
        newBookmarks[index] = response?.data
      }
      return newBookmarks
    })
    if (setRecoilBookmarks) {
      await setRecoilBookmarks(bookmarks => {
        const newBookmarks = [...bookmarks]
        const index = newBookmarks.findIndex(({ _id }) => _id === response?.data?._id)
        if (index !== -1) {
          // eslint-disable-next-line no-param-reassign
          newBookmarks[index] = response?.data
        }
        return newBookmarks
      })
    }
  } else {
    setBookmarks(bookmarks => [...(bookmarks || [])])
  }
  if (setTags) {
    updateTags(response?.data, setTags)
  }
  Toast.close('creating-editing-bookmark')
  return response?.data
}

export const deleteBookmark = async (bookmarkId, setBookmarks) => {
  const response = await api.delete(`/bookmarks/${bookmarkId}`)
  setBookmarks(bookmarks => bookmarks.filter(({ _id }) => _id !== bookmarkId))
  mutate('/folders')
  return response
}

export const deleteBookmarks = async bookmarksIds => {
  const response = await api.delete('/bookmarks', { data: { ids: bookmarksIds } })
  await mutate('/bookmarks')
  mutate('/folders')
  return response
}

export const updateMany = async (bookmarksIds, update) => {
  const response = await api.post('/bookmarks/many', { ids: bookmarksIds, update })
  await mutate('/bookmarks')
  return response
}

export const getBookmarkById = async (bookmarkId, query) => api.get(`/bookmarks/${bookmarkId}${query || ''}`)

export const getBookmarksFetcher = (url, axiosOptions = {}) => api.get(url, axiosOptions).then(res => res.data)

export async function searchBookmarks(query, folderId) {
  const response = await api.get(`/bookmarks/search?query=${query}&folderId=${folderId}`)
  return response.data
}

export function useGetBookmarks() {
  const { data, error, isLoading } = useSWR('/bookmarks', getBookmarksFetcher)

  return {
    bookmarks: data?.docs,
    isLoadingBookmarks: isLoading,
    isErrorBookmarks: error,
  }
}
